
import { Component } from 'vue-property-decorator'
import OptionSelector from '@/components/options/OptionSelector.vue'
import { MenuItem } from '@/interfaces/MenuItem'
import { useOptionStore } from '@/store/modules/options'
import { OptionValidator } from '@/mixins/OptionValidator'
import { mixins } from 'vue-class-component'

@Component({
  components: {
    OptionSelector
  }
})
export default class RoutableOptionsSelector extends mixins(OptionValidator) {
  public optionStore = useOptionStore();

  mounted() {
    this.optionStore.loadOptions(this.$route.params.productCode).then(() => {
      if (!this.menuItem) {
        const routeName = 'Size & Configuration'
        this.$router.push({ name: routeName, params: { productCode: this.model.code } })
      }
    })
  }

  get menuItem(): MenuItem | undefined {
    return this.optionStore
      .menuItems
      .filter(mi => mi.categories.some(c => !this.hideCategory(c)))
      .find(x => x.code === this.$route.params.menuItemUrl)
  }
}
